import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";


export class HarlequinIndividualWinAmountView extends PIXI.Container {

    private _individualWinTextContainer: PIXI.Container;

    constructor() {
        super();
        this.load()
    }

    public displayIndividualBetLineAmount(linesWinsData: IBetLineWinData): void {
        //  debugger;

        let betLineWinData: IBetLineWinData = linesWinsData;
        let betLine: number[] = betLineWinData.betLine;

        const symId: number = betLine[2];
        const basePosition: number[] = [144 * 2.5, symId * 200 + 300 + (symId === 0 ? 30 : symId === 2 ? -30 : 0)];

        const amountText: PIXI.BitmapText = new PIXI.BitmapText(Currency.formatValue(betLineWinData.multipliedAmount), {
            fontName: "fifthCountUp",
            fontSize: 50
        });
        amountText.maxWidth = 75;

        const amountContainer: PIXI.Container = new PIXI.Container();
        amountContainer.name = betLineWinData.betLineIndex.toString();
        amountText.position.set(basePosition[0], basePosition[1]);
        console.log(basePosition[0], basePosition[1]);

        amountText.pivot.x = amountText.textWidth * 0.5;
        amountText.pivot.y = amountText.textHeight * 0.5;
        amountContainer.addChild(amountText);
        // amountContainer.alpha = 0;
        /*    if (symId === 0) {
                amountContainer.y -= 40
            } else if (symId === 2) {
                amountContainer.y += 40;
            } else if (symId === 3) {
                amountContainer.y += 20;
            }*/
        this._individualWinTextContainer.addChild(amountContainer);


    }

    public individualLineAmountReset(): void {
        if (this._individualWinTextContainer.children.length > 0) {
            this._individualWinTextContainer.children.forEach((item) => {
                (<PIXI.Container>item).children.forEach((font) => {
                    font.destroy();

                });
            });
            this._individualWinTextContainer.removeChildren();
        }
    }

    private load(): void {
        this._individualWinTextContainer = new PIXI.Container();
        this._individualWinTextContainer.position.set(0, 0);
        this._individualWinTextContainer.name = "individualTextConTainer";
        this.addChild(this._individualWinTextContainer);
    }


}